import * as ActionAuth from '../../action/Auth';
import * as ActionFieldCustomer from '../../action/Customer/ActionFieldCustomer';
import * as ActionLogin from '../../../module/Login/Store';
import * as ActionTable from '../../action/Customer/ActionTableCustomer';
import * as ActionToggle from '../../action/toggle/index';

import { call, put, select, takeLatest } from 'redux-saga/effects';
import { changeLoadingFalse, changeLoadingTrue } from '../../action/toggle';

import { Modal } from 'antd';
import React from 'react';
import axios from 'axios';

export function* S_AddCustomer(action: any) {
  const state = yield select();
  const token = state.Auth.Token;
  const config = {
    Authorization: `bearer ${token}`,
    'Content-type': 'application/json',
  };
  const statusTokenRefresh = state.Auth.StatusTokenRefresh;
  const customername = state.Customer.DetailCustomer.CustomerName;
  const customercode = state.Customer.DetailCustomer.CustomerCode;
  const customertelephone = state.Customer.DetailCustomer.CustomerTelephone;
  const customeremail = state.Customer.DetailCustomer.CustomerEmail;
  const customeraddress = state.Customer.DetailCustomer.CustomerAddress;
  const customeraccess = state.Customer.DetailCustomer.CustomerAccess;
  let customertypeother =
    state.Customer.DetailCustomer.CustomerTypeOther === 'Lainnya'
      ? state.Customer.DetailCustomer.CustomerTypeOther
      : state.Customer.DetailCustomer.CustomerType;
  try {
    yield put(changeLoadingTrue());

    yield call(
      axios.post,
      process.env.REACT_APP_URL + '/Customer',
      {
        code: customercode,
        name: customername,
        customerType: customertypeother,
        phone: customertelephone,
        email: customeremail,
        address: customeraddress,
        image: null,
        access: customeraccess,
      },
      { headers: config }
    );
    if (statusTokenRefresh === true) {
      yield put(ActionAuth.changeStatusTokenRefresh(false));
    }
    yield put(ActionToggle.clearJenisToggle());
    yield put(ActionFieldCustomer.changeClearAllDataCustomer());
    yield put(ActionTable.ClearTableCustomer());
    yield put(changeLoadingFalse());
    yield put(ActionTable.GetTableCustomer());

    Modal.success({
      title: <p style={{ color: '#31E116' }}>Berhasil di simpan</p>,
      onOk() {},
    });
  } catch (error) {
    yield put(changeLoadingFalse());
    yield put(ActionLogin.errorHandling(action, error));
  }
}

export function* SM_AddCustomer() {
  yield takeLatest('SUBMIT_ADD_CUSTOMER', S_AddCustomer);
}
